module.exports = {
    textConstants: {
        aboutText: 'About Julie',
        bannerText: 'ASK JULIE',
        contactText: 'Contact Us',
        defaultErrorResponse : "A problem was encountered while processing the last request. Please try again later.",
        searchText: 'Search',
        submitContent: 'SEND',
        AutoNavigationWarning : "Are you sure you want to leave this page? Unsaved data may be lost.",
        disclaimer: "By using this chat, which utilizes both live agents and an automated chatbot, you acknowledge that you may communicate with a chatbot application during portions of the chat and you consent to the recording, monitoring, and storage of this conversation by Amtrak and our third-party vendor. Please see our Privacy Policy for additional information.",
        privacyText: "Privacy Policy",
    },
};



// WEBPACK FOOTER //
// ./settings/text-constants.js